import React from "react";
import * as actionTypes from "./actionTypes";
import {
  getOnboardingMaterialsAPI,
  createOnboardingMaterialAPI,
  updateOnboardinMaterialAPI,
  deleteOnboardingMaterialAPI,
} from "@icarius-connection/api";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";
import { openDialogAction } from "@icarius-common/dialog/actions";

const errorHandler = (e, dispatch) => {
  let errorString = "";
  switch (e.response?.data?.status) {
    case "INVALID_DATA":
    case "VALIDATION_ERROR":
      errorString = getLocalizedString("validationError");
      break;
    case "DUPLICATED_DATA":
      errorString = getLocalizedString("cannotExistMoreThanOneMaterialOrResourceWithTheSameCodeOrName");
      break;
    case "IN_USE":
      errorString = getLocalizedString("cannotDeleteMaterialOrResourceBecauseInUseInOnboardingProfiles");
      break;
    case "IN_USE_TYPE_ACTION":
      errorString = (
        <>
          {getLocalizedString("cantChangeActionMomentTypeOrCodeInUse1")}
          <br />
          {getLocalizedString("cantChangeActionMomentTypeOrCodeInUse2")}
        </>
      );
      break;
    default:
      errorString = getErrorStringFromServerError(e);
      break;
  }

  if (e.response?.data?.status === "IN_USE_TYPE_ACTION") {
    dispatch(openDialogAction({
      title: getLocalizedString("atention"),
      msg: errorString,
      acceptOnly: true,
      maxWidth: "md",
      fullWidth: true,
    }));
    return;
  }

  dispatch(openSnackbarAction({ msg: errorString, severity: "error" }));
}

export const getOnboardingMaterialsAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET });
  try {
    let response = await getOnboardingMaterialsAPI();

    let data = response.data && response.data.data;
    let actionList = response.data && response.data.actionList;
    let accessList = response.data && response.data.accessList;
    let pollList = response.data && response.data.pollList;
    let consentList = response.data && response.data.consentList;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_FULFILLED,
      payload: {
        data,
        actionList,
        accessList,
        pollList,
        consentList,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const deleteOnboardingMaterialAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE });
  try {
    let response = await deleteOnboardingMaterialAPI(dataToSend);

    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.DELETE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.DELETE_FULFILLED,
      payload: { data },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("onboardingMaterialDeleted"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.DELETE_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const createOnboardingMaterialAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE });
  try {
    let formData = new FormData();

    Object.keys(dataToSend).forEach((key) => {
      if (!dataToSend[key]) {
        formData.append(key, '');
        return;
      }

      formData.append(key, dataToSend[key])
    });

    let response = await createOnboardingMaterialAPI(formData);
    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.CREATE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.CREATE_FULFILLED,
      payload: { data },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("onboardingMaterialCreated"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.CREATE_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const updateOnboardinMaterialAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.MODIFY });
  try {
    let formData = new FormData();

    Object.keys(dataToSend).forEach((key) => {
      if (!dataToSend[key]) {
        if (key === 'keepFile') {
          formData.append(key, JSON.stringify(dataToSend[key]));
          return;
        }

        formData.append(key, '');
        return;
      }

      formData.append(key, dataToSend[key])
    });

    let response = await updateOnboardinMaterialAPI(formData);
    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.MODIFY_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.MODIFY_FULFILLED,
      payload: { data },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("onboardingMaterialModified"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.MODIFY_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};